<template>
	<ul id="vertical-nav" v-bind:class="getNavClass()">
		<template v-if="deviceType == 'mobile'">
			<li class="nav-btn" v-on:click="toggleMenu" v-bind:class="{'active':showMenu}">
				<img v-if="page !== '/permits'" src="../assets/css/svg/scoutred-icon.svg" class="hover-opacity" style="width:24px">
				<i v-else class="material-icons md-24">business_center</i>
				<ul class="expand-nav" v-if="showMenu">
					<li v-if="page !== '/permits'" v-on:click="permits" v-bind:class="{'active':page === '/permits'}">
						<div class="nav-left-icon">
							<i class="material-icons md-24">business_center</i>
						</div>
						<div class="nav-label">Permits</div>
					</li>
					<li v-else v-on:click="home" v-bind:class="{'active':page === '/home'}">
						<div class="nav-left-icon">
							<img src="../assets/css/svg/scoutred-icon.svg" class="hover-opacity" style="width:24px">
						</div>
						<div class="nav-label">Parcels</div>
					</li>
					<li v-if="planCurrentIsDayPass" v-on:click="plan" v-bind:class="{'active':page === '/plan'}">
						<div class="nav-left-icon">
							<div class="spinner spinner-sm">
								<div class="half right" :style="spinnerRight"></div>
								<div class="half cover" :style="spinnerCover"></div>
								<div class="half left" :style="spinnerLeft"></div>
								<div class="stop" :style="spinnerStop"></div>
							</div>
						</div>
						<div class="nav-label">Day pass</div>
					</li>
					<li v-if="planCurrentIsStudio" v-on:click="plan" v-bind:class="{'active':page === '/plan'}">
						<div class="nav-left-icon">
							<i class="material-icons md-24">verified_user</i>
						</div>
						<div class="nav-label">Studio subscription</div>
					</li>
					<li v-on:click="collections" v-bind:class="{'active':page === '/collections'}">
						<div class="nav-left-icon">
							<i class="material-icons md-24">folder_special</i>
						</div>
						<div class="nav-label">Parcel collections</div>
					</li>
					<li v-if="!token" v-on:click="agent" title="login or sign up" v-bind:class="{'active':page === '/auth'}">
						<div class="nav-left-icon">
							<i class="material-icons md-24">person_outline</i>
						</div>
						<div class="nav-label">Login or sign up</div>
					</li>
					<li v-if="token" v-on:click="agent" title="my account" v-bind:class="{'active':page === '/auth'}">
						<div class="nav-left-icon">
							<i class="material-icons md-24">person</i>
						</div>
						<div class="nav-label">User account</div>
					</li>
					<li v-on:click="message" title="message Scoutred" v-bind:class="{'active':page === '/auth'}">
						<div class="nav-left-icon">
							<i class="material-icons md-24">chat</i>
						</div>
						<div class="nav-label">Message Scoutred</div>
					</li>
				</ul>
			</li>
		</template>
		<template v-else>
			<li v-on:click="home" class="nav-item px-2 py-2 red" v-bind:class="{'active':page === '/'}">
				<img src="../assets/css/svg/scoutred-icon.svg" class="hover-opacity" style="width:2rem;">
				<div class="hint"><span>Parcels and zoning</span></div>
			</li>
			<li v-on:click="permits" class="nav-item px-2 py-2" v-bind:class="{'active':page === '/permits'}">
				<i class="material-icons md-36">business_center</i>
				<div class="hint"><span>Permits</span></div>
			</li>
			<li class="flex-2"></li>
			<li v-if="planCurrentIsDayPass" v-on:click="plan" class="nav-item px-2 py-2" v-bind:class="{'active':page === '/plan'}">
				<div class="spinner">
					<div class="half right" :style="spinnerRight"></div>
					<div class="half cover" :style="spinnerCover"></div>
					<div class="half left" :style="spinnerLeft"></div>
					<div class="stop" :style="spinnerStop"></div>
				</div>
				<div class="hint"><span>Day plan</span></div>
			</li>
			<li v-if="planCurrentIsStudio" v-on:click="plan" class="nav-item px-2 py-2" v-bind:class="{'active':page === '/plan'}">
				<i class="material-icons md-36">verified_user</i>
				<div class="hint"><span>Studio subscription</span></div>
			</li>
			<li v-if="token" v-on:click="collections" class="nav-item px-2 py-2" v-bind:class="{'active':page === '/collections'}">
				<i class="material-icons md-36">book</i>
				<div class="hint"><span>Parcel collections</span></div>
			</li>
			<li v-if="!token" v-on:click="agent" title="login or sign up" class="nav-item px-2 py-2" v-bind:class="{'active':page === '/auth'}">
				<i class="material-icons md-36">person_outline</i>
				<div class="hint"><span>Login or sign up</span></div>
			</li>
			<li v-if="token" v-on:click="agent" title="my account" class="nav-item px-2 py-2" v-bind:class="{'active':page === '/auth'}">
				<i class="material-icons md-36">person</i>
				<div class="hint"><span>User account</span></div>
			</li>
		</template>
	</ul>
</template>

<script>

import config from '../config';

export default {
	name: 'left-nav',

	computed: {
		deviceType:function(){
			return this.$store.state.device.type;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		page: function(){
			if (this.$route.path.indexOf('/collections') === 0) return '/collections';
			if (this.$route.path.indexOf('/permits') === 0) return '/permits';
			if (this.$route.path.indexOf('/plan') === 0) return '/plan';
			if (this.$route.path.indexOf('/auth') === 0) return '/auth';
			return '/';
		},
		spinnerCover:function(){
			const deg = 180 + ((this.spinnerPerc/100)*360);
			return 'transform:rotate('+deg+'deg);';
		},
		spinnerRight:function(){
			if (this.spinnerPerc > 50){
				return 'display:none;';
			}
		},
		spinnerLeft:function(){
			if (this.spinnerPerc > 50){
				return 'z-index:1;';
			}
		},
		spinnerStop:function(){
			if (this.spinnerPerc >= 100){
				return 'display:block;';
			}
			return 'display:none;';
		},
		planCurrent:function(){
			return this.$store.state.plan.current;
		},
		planCurrentIsDayPass:function(){
			if (!this.planCurrent) return false;
			return (!this.planCurrent.plan.recurring && this.planCurrent.plan.interval === 'day')? true: false;
		},
		planCurrentIsStudio:function(){
			if (!this.planCurrent) return false;
			return (this.planCurrent.plan.recurring)? true: false;
		},
		spinnerPerc:function(){
			if (!this.planCurrent) return 0;
			let currentPlanTs = new Date(this.planCurrent.created).getTime();
			const dayTs = 24*60*60*1000; 
			let left = (currentPlanTs + dayTs)-this.$data.nowTs;
			let perc = 100 - ((left/dayTs)*100);
			//perc = this.$data.timer;
			if (perc > 100) perc = 100;
			else if (perc < 0) perc = 0;
			return perc;
		}
	},
	mounted:function(){
		this.$data.nowTs = new Date().getTime();
		this.interval = setInterval(()=>{
			this.$data.nowTs = new Date().getTime();
		},60000);
	},
	data:function(){
		return {
			nowTs:0,
			showMenu:false
		};
	},
	destroyed:function(){
		if (this.interval) clearInterval(this.interval);
	},
	methods: {
		getNavClass:function(){
			if (this.deviceType === 'mobile'){
				return 'nav nav-mobile';
			}
			return 'd-flex nav flex-column';
		},
		agent: function(){
			if (this.token){
				return this.$router.push({name:'agent'});
				//return window.location = config.host.app+'/users/profile';
			}
			return this.$router.push({name:'auth'});
		},
		home: function(){
			return this.$router.push({name:'home'});
		},
		message: function(){
			this.$store.dispatch('MESSAGE_SHOW', {
				show:true
			})
		},
		plan: function(){
			return this.$router.push({name:'plan'});
		},
		collections: function(){
			return this.$router.push({name:'collections'});
		},
		auth: function(){
			this.$router.push({name: 'auth'});
		},
		logout: function(){
			this.$store.dispatch('LOGOUT');
		},
		permits: function(){
			return this.$router.push({name: 'permits'});
		},
		toggleMenu: function(){
			if (this.showMenu) return this.showMenu = false;
			this.showMenu = true;
		},
		toggleStyle: function(){
			if (this.$store.state.map.style == 'satellite') {
				this.$store.dispatch('SET_MAP_STYLE', {style: 'vector'});
				return;
			}

			this.$store.dispatch('SET_CARTO_STYLE', {style: 'satellite'});
		}
	}
}
</script>

<style>

#vertical-nav {
	text-align: center;
	position: relative;
	background-color: #263238;
	z-index:1001;
}
.mobile #vertical-nav {
	background-color: transparent;
}
#vertical-nav.nav-mobile{
	position:fixed;
	top:10px;left:10px;
}

.nav-btn{
	width:44px;
	height:44px;
	background-color:rgba(55,71,79,0.7);
	color:#FFFFFF;
	line-height:40px;
	text-align:center;
	border-radius:4px 0 0 4px;
}
.mobile .nav-btn{
	background-color:#263238;
}
.mobile .nav-btn.active{
	border-radius:4px 0 0 0;
}

.nav-item.active{
	color:#FFFFFF;
	background-color:#2C3A41;
}
.nav-item.active.red{
	color:#FFFFFF;
}
.nav-item{
	border-right:3px solid transparent;
	cursor:pointer;
	color:#CFD8DD;
	position:relative;
}
.nav-item:hover{
	color:#FFFFFF;
}

.expand-nav{
	position:absolute;
	left:0;top:44px;
	background-color:#263238;
	padding:0;
}
.expand-nav li{
	list-style-type:none;
	color:#FFF;
	overflow:hidden;
	position:relative;
}
.nav-left-icon{
	position:absolute;
	width:44px;
	height:44px;
	top:0;left:0;
}
.nav-label{
	margin:0 10px 0 44px;
	white-space: nowrap;
	line-height:44px;
	text-align: left;
}

.spinner {
	width: 36px;
	height: 36px;
	position: relative;
	border:5px solid #CFD8DD;
	border-radius:18px;
	left:1px;
}
.spinner-sm{
	transform:scale(0.66,0.66);
	top:4px;
	left:4px;
}
.nav-item:hover .spinner {
	border-color:#FFFFFF;
}

.spinner .half.cover{
	background-color:#263238;
	transform: rotate(-90deg);
}

.spinner .half{
	border-radius: 0 18px 18px 0;
	background-color:#92CC17;
	width: 9px;
	height: 18px;
	top:4px;
	left:13px;
	position:absolute;
	transform: rotate(180deg);
	transform-origin:0 9px;
	z-index:2;
}

.spinner .half.left{
	transform: rotate(180deg);
}
.spinner .half.right{
	transform: rotate(0deg);
}
.spinner .stop{
	z-index:3;
	position:absolute;
	width:12px;
	height:12px;
	left:7px;
	top:7px;
	background-color:#CC1717;
}

.nav-item:hover .hint{display:block;}
.hint{
	position:absolute;
	left:60px;
	z-index:1000;
	top:0.6rem;
	background-color:#2C3A41;
	color:#FFFFFF;
	white-space:nowrap;
	padding:0.25rem 0.5rem;
	border-radius:0.25rem;
	display:none;
}
.hint span:after{
	content:'';
	position:absolute;
	left:-6px;
	top:0.75rem;
	width:6px;
	height:8px;
	border-top:4px solid transparent;
	border-right:6px solid #2C3A41;
	border-bottom:4px solid transparent;
}

</style>


// WEBPACK FOOTER //
// src/components/left-nav.vue